import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminTypicalProjects = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.TYPICAL_PROJECTS.GET_ALL, { params });
    return response.data;
};
export const getAdminTypicalProjectById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.TYPICAL_PROJECTS.GET_BY_ID(id));
    return response.data;
};
export const createTypicalProject = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.TYPICAL_PROJECTS.CREATE, data);
    return response.data;
};
export const updateTypicalProject = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.TYPICAL_PROJECTS.UPDATE(id), data);
    return response.data;
};
export const deleteTypicalProject = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.TYPICAL_PROJECTS.DELETE(id));
    return response.data;
};

